import { Node, mergeAttributes } from "@tiptap/core";

export interface RecommendedPropertiesOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    recommendedProperties: {
      setRecommendedProperties: (options: {
        propertyIds: string[];
      }) => ReturnType;
    };
  }
}

export const RecommendedProperties = Node.create<RecommendedPropertiesOptions>({
  name: "recommendedProperties",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  group: "block",

  atom: true,

  addAttributes() {
    return {
      propertyIds: {
        default: [],
        parseHTML: (element) => {
          const ids = element.getAttribute("data-property-ids");
          return ids ? ids.split(",") : [];
        },
        renderHTML: (attributes) => {
          if (!attributes.propertyIds || !Array.isArray(attributes.propertyIds)) {
            return {};
          }
          return {
            "data-property-ids": attributes.propertyIds.join(","),
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-type='recommended-properties']",
      },
    ];
  },

  renderHTML({ HTMLAttributes, node }) {
    const propertyIds = node.attrs.propertyIds || [];
    const count = propertyIds.length;
    
    const children: Array<string | [string, Record<string, string>, string]> = [
      [
        "span",
        { class: "recommended-properties-icon" },
        "🏠",
      ],
      [
        "span",
        { class: "recommended-properties-text" },
        "Recommended Properties for you",
      ],
    ];
    
    if (count > 0) {
      children.push([
        "span",
        { class: "recommended-properties-count" },
        `(${count} ${count === 1 ? "property" : "properties"})`,
      ]);
    }
    
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": "recommended-properties",
        class: "recommended-properties-placeholder",
      }),
      [
        "div",
        { class: "recommended-properties-placeholder-content" },
        ...children,
      ],
    ];
  },

  addCommands() {
    return {
      setRecommendedProperties:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              propertyIds: options.propertyIds,
            },
          });
        },
    };
  },
});

